import React from "react";
import "./Contact.scss";
import { contacts } from "../../../Data";
import { socialIcons } from "../../../Data";
import { motion } from "framer-motion";
import { FaFacebookSquare, FaWhatsappSquare } from "react-icons/fa";
import { BsGithub, BsLinkedin } from "react-icons/bs";

const Contact = () => {
  const handleSendMessage = (e) => {
    window.location.reload();
  };

  return (
    <div className="container" id="contact">
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ y: [-50, 0], opacity: 1 }}
        className="title"
      >
        <span>get in touch</span>
        <h1>Contact Me</h1>
      </motion.div>
      <div className="contact_form">
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [-150, 0], opacity: 1 }}
          transition={{ duration: 1 }}
          className="contact_left_container"
        >
          <h3>Say Hi To Me</h3>

          {/* ===================================================================================== */}
          {/* <p className='contact_text'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse nihil unde atque voluptates, cumque molestias eveniet voluptatum animi consectetur magni mollitia dolor exercitationem labore maiores!</p> */}
          {/* ===================================================================================== */}

          {contacts.map((contact) => {
            return (
              <div className="contact_left" key={contact.id}>
                <div className="icon">{contact.icon}</div>
                <p>{contact.infoText}</p>
              </div>
            );
          })}

          <div className="social_icons">
            {/* {socialIcons.map((socialIcon, index) => {
              return <div key={index}>{socialIcon}</div>;
            })} */}
            <div>
              <a
                href="https://github.com/HossainRafi"
                target="_blank"
                rel="noreferrer"
              >
                <BsGithub />
              </a>
            </div>
            <div>
              <a
                href="https://www.linkedin.com/in/-rafi"
                target="_blank"
                rel="noreferrer"
              >
                <BsLinkedin />
              </a>
            </div>
            <div>
              <a
                href="https://web.whatsapp.com"
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsappSquare />
              </a>
            </div>
            <div>
              <a
                href="https://web.facebook.com/rafi.barishal/"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebookSquare />
              </a>
            </div>
          </div>
        </motion.div>
        <motion.div
          initial={{ x: 0, opacity: 0 }}
          whileInView={{ x: [150, 0], opacity: 1 }}
          transition={{ duration: 1 }}
          className="contact_right"
        >
          <h3>Send Me A Message</h3>
          <form
            action="https://formsubmit.co/hossainrafi71@gmail.com"
            method="POST"
            target="_blank"
          >
            <div className="row">
              <input
                type="text"
                name="name"
                required
                placeholder="Enter Your Name"
              />
            </div>
            <div className="row">
              <input
                type="email"
                name="email"
                required
                placeholder="Enter Your Email"
              />
            </div>
            <div className="row">
              <textarea
                name="message"
                required
                placeholder="Write Your Message........"
              ></textarea>
            </div>
            <motion.div
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.3 }}
              className="btn"
            >
              <button type="submit" onClick={handleSendMessage}>
                Send Message
              </button>
            </motion.div>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
